import React from "react";
import { Box, Tabs, Tab } from "@mui/material";
import Heading from "./Heading"; // Ensure correct import

interface VerticalTabsProps {
  GetTabs: () => { Text: string; Component: React.ReactNode }[];
}

const VerticalTabs: React.FC<VerticalTabsProps> = (props) => {
  const [value, setValue] = React.useState(0);

  const tabs = props.GetTabs();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <Box className="d-flex">
        <Tabs
          orientation="vertical"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{
            borderRight: 1,
            borderColor: "divider",
            width: 130,
          }}
        >
          {tabs &&
            tabs.map((tab, index) => (
              <Tab
                key={index}
                label={
                  <Heading
                    type={"caption"}
                    text={tab.Text}
                    classes="sentence-case"
                    isBold={value === index}
                  />
                }
                sx={{ padding: 1 }}
              />
            ))}
        </Tabs>
        <Box sx={{ paddingLeft: 2, width: "calc(100% - 150px)" }}>
          {tabs && tabs[value] && tabs[value].Component}
        </Box>
      </Box>
    </>
  );
};

export default VerticalTabs;
